import './prize-draw-form.scss';

class PrizeDrawForm {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-prizedrawform',
            legalAttr: 'legal',
            modalAttr: 'data-modal'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$prizeDrawForm = $element;
        this.$prizeDrawFormLegal = this.$prizeDrawForm.querySelectorAll(`[${this.settings.initAttr}="${this.settings.legalAttr}"]`);

        this.initialize();
    }

    initialize () {
        this.$prizeDrawFormLegal.forEach(($prizeDrawLegal) => {
            this.initLegal($prizeDrawLegal);
        });
    }

    initLegal ($legal) {
        const $links = $legal.querySelectorAll('a');

        $links.forEach(($link) => {
            const linkHref = $link.getAttribute('href');

            if (linkHref) {
                const $modalLink = document.querySelector('a[href="' + linkHref + '"][data-modal]');

                if ($modalLink) {
                    $link.addEventListener('click', (e) => {
                        $modalLink.dispatchEvent(new Event('click'));
                        e.preventDefault();
                    });
                }
            }
        });
    }
}

export { PrizeDrawForm };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$prizeDrawForm = $context.querySelectorAll('[data-prizedrawform="root"]');
        for (let i = 0; i < $$prizeDrawForm.length; i++) {
            const $prizeDrawForm = $$prizeDrawForm[i];

            const prizeDrawFormAPI = new PrizeDrawForm($prizeDrawForm);
            $prizeDrawForm.API = prizeDrawFormAPI;
        }
    }
});
